import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { Angular2SignaturepadModule } from 'angular2-signaturepad';
import {SignaturePadModule} from '@tdo-inc/tdox-signaturepad/dist/tdox-signaturepad';

import { FormsItemComponent } from './forms-item.component';
import { FormsGlobals } from '../../../models/forms/forms.enum';
import { FormsItemModalModule } from '../forms-item-modal/forms-item-modal.module';

import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';
import {DirectivesModule} from '../../../directives/directives.module';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
    declarations: [
        FormsItemComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        FormsItemModalModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSliderModule,
        MatSelectModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
      SignaturePadModule,
        MatDialogModule,
        TdoControlsModule,
        DirectivesModule,
        MatIconModule
    ],
    exports: [
        FormsItemComponent
    ],
    providers: [
        FormsGlobals,
    ]
})
export class FormsItemModule { }
